/* globals sh_single_idea_config */

import { createApp } from 'vue';

import { rest_request } from './_partials/_rest.js';
import App from './single-idea-app/app.vue';

(function () {
	const container_el = document.getElementById(`js-single-idea-vote`);
	if (!container_el) {
		return;
	}

	const button_els = container_el.querySelectorAll(`.btn`);

	function on_click(e) {
		const choice = e.currentTarget.dataset.choice;

		rest_request(`ideas/vote`, {
			method: `POST`,
			data: {
				post_id: parseInt(container_el.dataset.post_id, 10),
				choice,
			},
		}).catch(() => {
			// Do nothing
		});

		for (const button_el of button_els) {
			button_el.disabled = true;
		}
	}

	for (const button_el of button_els) {
		button_el.addEventListener(`click`, on_click);
	}
})();

(function () {
	const app_el = document.getElementById(`js-single-idea-app`);
	if (!app_el) {
		return;
	}

	if (typeof sh_single_idea_config === `undefined`) {
		return;
	}

	if (sh_single_idea_config.posts.length === 0) {
		return;
	}

	const app = createApp(App, sh_single_idea_config);

	app.mount(app_el);
})();
